import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
import { Modal } from "bootstrap";
const VarietyForm = (props) => {
  const frmRef = useRef({});
  const modalRef = useRef(null);

  const [close, setClose] = useState(false);
  const [cropclose, setCropClose] = useState(false);

  const [cropVarietyData, setCropVarietyData] = useState([]);
  const [croptypeId, setCroptypeId] = useState([]);
  const [croptypePopId, setCroptypePopId] = useState([]);

  const [cropId, setCropId] = useState([]);
  const [productItemTypeList, setProductItemTypeList] = useState([]);

  const [cropTypeList, setCropTypeList] = useState([]);
  const [cropList, setCropList] = useState([]);

  const [cropFilterList, setCropFilterList] = useState([]);

  const [attachmentUrl, setAttachmentUrl] = useState("");

  const { sendRequest: getUnits } = useHttp();

  const [areaUnit, setAreaUnit] = useState([]);
  const [productionUnit, setProductionUnit] = useState([]);

  const [productionUnitId, setProductionUnitId] = useState(0);
  const [production, setProduction] = useState("");

  const [areaUnitId, setAreaUnitId] = useState(0);

  const getUnitsDetail = () => {
    getUnits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          const filterAreaUnits =
            res && res.filter((itm) => itm.unitTypeName === "Area");
          // console.log("units", filterAreaUnits);

          setAreaUnit(filterAreaUnits);

          const filterProductionUnits =
            res && res.filter((itm) => itm.unitTypeName === "Weight");
          //   console.log("units", filterAreaUnits);

          setProductionUnit(filterProductionUnits);
        }
      }
    );
  };

  useEffect(() => {
    getUnitsDetail();
  }, [getUnits]);

  const cropTypeOnchangedHandler = (event) => {
    //console.log(event.target.value);

    var croptype = event.target.value;
    setCroptypeId(event.target.value);
    setCropFilterList([]);

    const cropFilterList = cropList.filter(
      (item) => parseInt(item.croptypeId) === parseInt(croptype)
    );

    setCropFilterList(cropFilterList);
  };

  const { sendRequest: getcropType } = useHttp();
  const fillCropType = () => {
    getcropType(
      {
        url: "/api/croptypes/",
      },
      (res) => {
        if (res) {
          //console.log("CropType", res);
          setCropTypeList(res);
        }
      }
    );
  };

  useEffect(() => {
    fillCropType();
  }, [getcropType]);

  const { sendRequest: getcrop } = useHttp();
  const fillCrop = () => {
    getcrop(
      {
        url: `/api/crops/?createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setCropList(res);

          const cropFilterList = res.filter(
            (item) => parseInt(item.croptypeId) === parseInt(croptypeId)
          );

          setCropFilterList(cropFilterList);
        }
      }
    );
  };

  useEffect(() => {
    fillCrop();
  }, [getcrop]);
  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: `/api/varieties/?createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setCropVarietyData(res);
          // console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const { sendRequest: getProductitemtypes } = useHttp();

  const getproductitemDetail = () => {
    getProductitemtypes(
      {
        url: "/api/fillProductTypesWithoutServices/",
      },
      (res) => {
        if (res) {
          // //console.log("productitemtypes", res);
          setProductItemTypeList(res);
        }
      }
    );
  };

  useEffect(() => {
    getproductitemDetail();
  }, [getProductitemtypes]);

  const { sendRequest: postCrop } = useHttp();

  const cropsubmitHandler = (e) => {
    e.preventDefault();

    if (attachmentUrl != "") {
      const data = {
        cropName: frmRef.current.cropName.value.trim(),
        cropNo: frmRef.current.cropNo.value.trim(),
        croptypeId: frmRef.current.croptypePopId.value,
        cropProfileUrl: attachmentUrl,
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        createdDate: new Date(),
        serviceId: props.sId,
      };
      // if (props.update || purchaseorderId) {
      //   data["purchaseorderId"] = purchaseorderId;
      // }
      // //console.log(data);
      postCrop(
        {
          url: "/api/crops/",

          method: "POST",
          body: data,
        },
        (data) => {
          toast.success(data);

          setCropClose(false);
          frmRef.current.cropName.value = "";
          frmRef.current.cropNo.value = "";
          frmRef.current.croptypePopId.value = "";
          setCroptypeId("")

          setimagePreviewUrl("");

          setAttachmentUrl("");
          const modalElement = document.getElementById("modal-cropDetail");
          const cropModal = Modal.getOrCreateInstance(modalElement);
          cropModal.hide();
          fillCrop();
        },
        (error) => {
          toast.error(error);
        }
      );
    } else {
      toast.warn("Upload Attachment");
    }
  };

  const { sendRequest: postCropType } = useHttp();

  const cropTypesubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      cropTypeName: frmRef.current.cropTypeName.value.trim(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
    };

    postCropType(
      {
        url: "/api/croptypes/",

        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(data);

        frmRef.current.cropTypeName.value = "";
        fillCropType();
        modalRef.current.visible = false;
        setClose(false);
      },
      (error) => {
        toast.error(error);
      }
    );
  };

  const { sendRequest: postCropVariety } = useHttp();

  const cropVarietysubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      varietyName: frmRef.current.varietyName.value.trim(),
      varietyNo: frmRef.current.varietyNo.value.trim(),
      cropId: frmRef.current.cropId.value,
      AvgDaysToHarvest: frmRef.current.AvgDaysToHarvest.value,
      cropDuration: frmRef.current.cropDuration.value,
      unitProduction: production,
      productionUnitId: productionUnitId,
      productionAreaUnitId: areaUnitId,
      serviceId: props.sId,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
    };

    //console.log(data);
    postCropVariety(
      {
        url: "/api/varieties/",

        method: "POST",
        body: data,
      },
      (data) => {
        console.log(data);

        toast.success(data);

        props.addForm(false);
      },
      (error) => {
        toast.error(error);
      }
    );
  };

  const [imagePreviewUrl, setimagePreviewUrl] = useState(null);

  const AttachmentUpload = (e) => {
    const attachmentFolder = localStorage.getItem("attachmentFolder");
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/CropAttachment/${new Date().valueOf()}/${file.name
      }`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setAttachmentUrl(data.url);
        const reader = new FileReader();
        reader.onloadend = () => {
          setimagePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      })
      .catch((err) => console.error(err));
  };
  return (
    <>
      <div className="modal fade" id="modal-sm">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <label className="modal-title">Add Crop Type Detail</label>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form style={{ margin: "10px" }} onSubmit={cropTypesubmitHandler}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Crop Type Name</label>
                  <input
                    type={"text"}
                    id={"cropTypeName"}
                    required
                    ref={(el) => (frmRef.current["cropTypeName"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-cropDetail" ref={modalRef}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <label className="modal-title">Add Crop Detail</label>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={cropsubmitHandler}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Croptype Name</label>
                  <select
                    id="croptypePopId"
                    className="form-control"
                    ref={(el) => (frmRef.current["croptypePopId"] = el)}
                    value={croptypePopId}
                    onChange={(e) => {
                      setCroptypePopId(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select Crop Type</option>

                    {cropTypeList &&
                      cropTypeList.map((x) => (
                        <option
                          key={x.croptypeId}
                          value={x.croptypeId}
                        >
                          {x.cropTypeName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Crop Name</label>
                  <input
                    type={"text"}
                    id={"cropName"}
                    required
                    ref={(el) => (frmRef.current["cropName"] = el)}
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Crop No</label>
                  <input
                    type={"text"}
                    id={"cropNo"}
                    required
                    ref={(el) => (frmRef.current["cropNo"] = el)}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Upload Attachment</label> &nbsp;
                  <label className="custom-attach-upload">
                    <input
                      onChange={AttachmentUpload}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                    />
                    <i
                      className="fas fa-solid fa-upload"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </label>
                  <div className="image-preview">
                    <img
                      src={imagePreviewUrl}
                      loader={<img src={imagePreviewUrl} />}
                      alt="Attachment"
                      style={{ maxWidth: "100px", maxHeight: "80px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form onSubmit={cropVarietysubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Variety Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <div>
                          {" "}
                          <label>Crop Type </label>
                          <button
                            type="button"
                            className="btn-primary"
                            data-toggle="modal"
                            data-target="#modal-sm"
                          >
                            +
                          </button>
                        </div>
                        <select
                          id="cropTypeNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropTypeNameId"] = el)}
                          value={croptypeId}
                          onChange={cropTypeOnchangedHandler}
                          required
                        >
                          <option value="">Select Crop Type</option>

                          {cropTypeList &&
                            cropTypeList.map((x) => (
                              <option
                                key={x.croptypeId}
                                value={x.croptypeId}
                              >
                                {x.cropTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Name </label>
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-cropDetail"
                        >
                          +
                        </button>

                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropId"] = el)}
                          value={cropId}
                          onChange={(e) => {
                            setCropId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Crop</option>
                          {cropFilterList &&
                            cropFilterList.map((x) => (
                              <option
                                key={x.cropId}
                                crop-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Variety name</label>

                        <input
                          type="text"
                          id="varietyName"
                          className="form-control"
                          ref={(el) => (frmRef.current["varietyName"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Variety No</label>
                        <input
                          type="text"
                          id="varietyNo"
                          className="form-control"
                          ref={(el) => (frmRef.current["varietyNo"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Avg Days to Harvest(Days)</label>
                        <input
                          type="number"
                          id="AvgDaysToHarvest"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["AvgDaysToHarvest"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Duration(Days)</label>
                        <input
                          type="number"
                          id="cropDuration"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropDuration"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit Of Area</label>
                        <select
                          id="gradeType"
                          className="form-control"
                          value={areaUnitId}
                          onChange={(e) => {
                            setAreaUnitId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select</option>

                          {areaUnit &&
                            areaUnit.map((x) => (
                              <option key={x.unitId} value={x.unitId}>
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Estimated Production/Unit Area</label>
                        <input
                          type="number"
                          id="grade Name"
                          className="form-control"
                          autoComplete="off"
                          value={production}
                          onChange={(e) => {
                            setProduction(e.target.value);
                          }}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Production Unit</label>
                        <select
                          id="gradeType"
                          className="form-control"
                          value={productionUnitId}
                          onChange={(e) => {
                            setProductionUnitId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select</option>

                          {productionUnit &&
                            productionUnit.map((x) => (
                              <option key={x.unitId} value={x.unitId}>
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default VarietyForm;
